import template from './email.html';
import controller from './email.controller';
import './email.scss';

let emailComponent = {
  bindings: {},
  template,
  controller
};

export default emailComponent;



// WEBPACK FOOTER //
// ./client/app/components/email/email.component.js